import request from '@/utils/request'

// 查询菜单列表
export function listMenu(query) {
  return request({
    url: '/admin/menu/list',
    method: 'get',
    params: query
  })
}

// 查询菜单详细
export function getMenu(menuId) {
  return request({
    url: '/admin/menu/' + menuId,
    method: 'get'
  })
}

// 查询菜单下拉树结构
export function treeselect() {
  return request({
    url: '/admin/menu/treeselect',
    method: 'get'
  })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
  return request({
    url: '/admin/menu/roleMenuTreeselect/' + roleId,
    method: 'get'
  })
}

// 新增菜单
export function addMenu(data) {
  return request({
    url: '/admin/menu',
    method: 'post',
    data: data
  })
}

// 修改菜单
export function updateMenu(data) {
  return request({
    url: '/admin/menu',
    method: 'put',
    data: data
  })
}

//修改菜单可用状态
export function updateMenuStatus(data) {
  return request({
    url: '/admin/menu/status',
    method: 'put',
    data: data
  })
}

//修改菜单显示状态
export function updateMenuVisible(data) {
  return request({
    url: '/admin/menu/visible',
    method: 'put',
    data: data
  })
}

// 保存菜单排序
export function updateMenuSort(data) {
  return request({
    url: '/admin/menu/updateSort',
    method: 'put',
    data: data
  })
}

// 删除菜单
export function delMenu(menuId) {
  return request({
    url: '/admin/menu/' + menuId,
    method: 'delete'
  })
}
